import React, { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import Sidebar from "../Sidebar";
import UploadMacrosPanel from "./UploadMacrosPanel";

const TOOLS_TABS = [
  { key: 'upload-macros', label: 'Upload Macros' },
];

const Tools = ({ setAuth, setUserOrg }) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [activeTab, setActiveTab] = useState('upload-macros');

  useEffect(() => {
    const tabFromUrl = searchParams.get('tab');
    if (tabFromUrl) {
      const validTab = TOOLS_TABS.find(tab => tab.key === tabFromUrl);
      if (validTab) {
        setActiveTab(tabFromUrl);
      } else {
        setActiveTab('upload-macros');
        setSearchParams({ tab: 'upload-macros' });
      }
    } else {
      setActiveTab('upload-macros');
      setSearchParams({ tab: 'upload-macros' });
    }
  }, [searchParams, setSearchParams]);

  return (
    <div className="flex">
      <div className="h-[100dvh]">
        <div className="flex h-[100%] fixed top-0">
          <Sidebar setAuth={setAuth} setUserOrg={setUserOrg} />
        </div>
      </div>
      <div
        className="pl-[10px] pr-[10px] flex flex-col w-full overflow-x-hidden transition-all duration-200"
        style={{ marginLeft: "var(--sidebar-width, 250px)" }}
      >
        <div className="flex flex-col w-full">
          <div className="flex flex-col justify-center items-center w-full">
            <h1 className="font-bold text-[28px] text-ktx-purple mt-[2rem]">
              Customer Success Tools
            </h1>
            <div className="mt-8 w-full flex border-b border-gray-200">
              {TOOLS_TABS.map(tab => (
                <button
                  key={tab.key}
                  className={`px-4 py-2 text-sm font-medium focus:outline-none transition-colors border-b-2 ${activeTab === tab.key ? 'border-ktx-purple text-ktx-purple' : 'border-transparent text-gray-600 hover:text-ktx-purple'}`}
                  onClick={() => {
                    setActiveTab(tab.key);
                    setSearchParams({ tab: tab.key });
                  }}
                  type="button"
                >
                  {tab.label}
                </button>
              ))}
            </div>
            <div className="w-full mt-6">
              {activeTab === 'upload-macros' && (
                <div className="w-full">
                  <UploadMacrosPanel />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Tools;
